export default function Representative() {
  return (
    <section className="py-24 px-8 bg-white">
      <div className="max-w-[1000px] mx-auto">
        <h2 className="text-3xl md:text-4xl font-black text-gray-900 mb-16 text-center">
          代表メッセージ
        </h2>
        
        <div className="grid grid-cols-1 md:grid-cols-[300px_1fr] gap-12 items-start">
          <div className="mx-auto md:mx-0">
            <div 
              className="w-64 h-64 rounded-lg bg-cover bg-center bg-gray-200"
              style={{
                backgroundImage: 'url(https://static.readdy.ai/image/4b210e4d3d9fe9a73b886d10fa116566/2912b9bbbb01cabc6aef808a9f1e3388.jpeg)'
              }}
            ></div>
            <div className="mt-6 text-center md:text-left">
              <p className="text-xl font-bold text-gray-900">油谷 和好</p>
              <p className="text-sm text-gray-600 mt-1">代表</p>
            </div>
          </div>
          
          <div className="space-y-6">
            <p className="text-base text-gray-700 leading-relaxed">
              EC事業の現場で30年以上、数多くの企業様の成長を支援してまいりました。
            </p>
            
            <p className="text-base text-gray-700 leading-relaxed">
              多くの企業が「施策が増えるほど成果が見えなくなる」「外注が多く判断が遅れる」「何に投資すべきか分からない」という課題を抱えています。これは、Web・EC・SNS・広告が分断され、全体を見て優先順位を決める人がいないことが原因です。
            </p>
            
            <p className="text-base text-gray-700 leading-relaxed">
              私たちは、最新のAI技術による客観的なデータ分析と、30年の実務経験から得た知見を組み合わせることで、「やるべきこと」以上に「やらないこと」を明確にし、限られたリソースを最も効果的な施策に集中させます。
            </p>
            
            <p className="text-base text-gray-700 leading-relaxed">
              戦略立案だけで終わらせず、実装・運用まで一気通貫でサポートする伴走型のコンサルティングで、EC事業の自動化と成長を実現します。
            </p>
            
            <p className="text-base text-gray-700 leading-relaxed">
              まずは無料相談で、現状の課題を整理し、次の一手を一緒に考えさせていただければ幸いです。
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
